var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.preliminary.published_at || _vm.final.published_at)?_c('div',{staticClass:"diagnosis"},[(
      (_vm.preliminary.published_at && _vm.authType !== 'Patient') ||
        (_vm.authType === 'Patient' &&
          _vm.preliminary.published_at &&
          !_vm.final.published_at)
    )?_c('diagnosis-published',{attrs:{"value":_vm.value,"item-id":_vm.preliminary.id,"type":"preliminary"}}):_vm._e(),(_vm.final.published_at)?_c('diagnosis-published',{attrs:{"value":_vm.value,"item-id":_vm.final.id,"type":"final"}}):_vm._e()],1):_c('div',{staticClass:"alert alert-secondary mt-3"},[_vm._v(" "+_vm._s(_vm.$t('nodiagnosis'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }